import React from 'react';
import './Modal.css';
import plannerIcon from "../../assets/images/Icon=planner.svg";
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import { t } from '../../locales/translate';

const SubmitPlanModal = ({ isVisible, onClose, onSubmitClick, isLoading }) => {

    return (
        isVisible && (
            <div className="modal-backdrop">
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <div className='content-container'>
                        <div className='icon-container'>
                            <img src={plannerIcon} />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text={t("submitPlan")} />
                            <BodyMediumRegular
                                color='#384153'
                                text={t("submitPlanTip")}
                                textAlign='center'
                            />
                        </div>
                    </div>
                    <div className='button-contiainer'>
                        <button className='cancel-button'
                            onClick={onClose}
                             style={{width:  document.body.dir === "rtl" ? "119px" : ""}}
                        >
                            <p className="button-text">{t("cancel")}</p>
                        </button>
                        <button className='primary-button' onClick={onSubmitClick} disabled={isLoading}  style={{width:  document.body.dir === "rtl" ? "123px" : ""}}>
                            <p className="button-text save">{t("submit")}</p>
                        </button>

                    </div>
                </div>
            </div>
        )
    );
};

export default SubmitPlanModal;
